/**
 * Service HttpClientService
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';

import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class HttpClientService {
  constructor(private _http: HttpClient, private cookieService: CookieService) {

  }

  private _createAuthorizationHeader(headers: HttpHeaders) {
    let token = this.cookieService.get('token');
    let h: HttpHeaders = headers ? headers : new HttpHeaders();
    if (token)
      h = h.set('Authorization', 'Bearer ' + token);
    return h;
  }

  get(url: string, h?: HttpHeaders) {
    let headers = this._createAuthorizationHeader(h);
    return this._http.get(url, { headers: headers });
  }

  post(url: string, body: string, h: HttpHeaders) {
    let headers = this._createAuthorizationHeader(h);
    return this._http.post(url, body, { headers: headers });
  }

  put(url: string, body: string, h: HttpHeaders) {
    let headers = this._createAuthorizationHeader(h);
    return this._http.put(url, body, { headers: headers });
  }

  delete(url: string, h?: HttpHeaders) {
    let headers = this._createAuthorizationHeader(h);
    return this._http.delete(url, { headers: headers });
  }
}
